import { render, staticRenderFns } from "./canteenOrder.vue?vue&type=template&id=7dcbd427&"
import script from "./canteenOrder.vue?vue&type=script&lang=js&"
export * from "./canteenOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports